// extracted by mini-css-extract-plugin
module.exports = {"container":"started_container__Er97T"};